'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _EditorialLabel = require('./EditorialLabel');

var _EditorialLabel2 = _interopRequireDefault(_EditorialLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/editorial-label')(_EditorialLabel2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/editorial-label/lib/cjs/index.js
 ** module id = 720
 ** module chunks = 1
 **/